/* Bright & Shiny wishlist. Product interest only: no variant/options/cart operations. */
(() => {
  'use strict';
  const config = document.getElementById('bsw-config');
  const dialog = document.getElementById('bsw-dialog');
  if (!config || !dialog || window.BSWishlist) return;
  const root = /^\/[a-zA-Z0-9/-]*$/.test(config.dataset.root) ? config.dataset.root : '/';
  const proxy = config.dataset.proxy;
  const enabled = config.dataset.enabled === 'true' && /^\/apps\/[a-zA-Z0-9_-]+$/.test(proxy);
  // Only a local partition / expected-context check. Identity is verified by Shopify on the server.
  const customer = /^[1-9][0-9]{0,19}$/.test(config.dataset.customer) ? config.dataset.customer : '';
  const key = 'bsw:v1:';
  const itemKey = key + 'item:';
  const pendingKey = key + 'pending:' + customer;
  const t = name => config.dataset['text' + name.replace(/(^|_)([a-z])/g, (_, p, c) => c.toUpperCase())] || name;
  const validID = value => typeof value === 'string' && /^[1-9][0-9]{0,19}$/.test(value);
  const validHandle = value => typeof value === 'string' && /^[a-zA-Z0-9][a-zA-Z0-9_-]{0,254}$/.test(value);
  const uuid = () => crypto.randomUUID();
  let storageOK = true, busy = false, mode = 'device', server = [], message = '', retry = false;
  let opener, toastTimer, hydrated = new Map(), catalog = new Map(), hydrateRun = 0;
  const parse = value => { try { return JSON.parse(value); } catch (_) { return null; } };
  function read(name) { try { return localStorage.getItem(name); } catch (_) { storageOK = false; return null; } }
  function write(name, value) {
    try { if (value === null) localStorage.removeItem(name); else localStorage.setItem(name, JSON.stringify(value)); }
    catch (_) { storageOK = false; throw new Error('storage_error'); }
  }
  function localItems() {
    const items = [];
    try {
      for (let i = 0; i < localStorage.length; i++) {
        const name = localStorage.key(i);
        if (!name?.startsWith(itemKey)) continue;
        const item = parse(localStorage.getItem(name));
        if (item && validID(item.product_id) && name === itemKey + item.product_id && validHandle(item.handle) && typeof item.token === 'string') items.push(item);
      }
    } catch (_) { storageOK = false; }
    return items.sort((a, b) => (b.at || 0) - (a.at || 0));
  }
  function imageURL(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try { const u = new URL(value, location.origin); return u.protocol === 'https:' && (u.hostname === location.hostname || u.hostname === 'cdn.shopify.com' || u.hostname.endsWith('.shopify.com')) ? u.href : ''; }
    catch (_) { return ''; }
  }
  const productURL = handle => root + 'products/' + encodeURIComponent(handle);
  function items() {
    const map = new Map(localItems().map(item => [item.product_id, {...item, local: true}]));
    if (mode === 'account') for (const item of server) {
      const metadata = catalog.get(item.product_id) || map.get(item.product_id) || {};
      let handle = metadata.handle;
      if (item.url) {
        try { const part = new URL(item.url, location.origin).pathname.split('/products/')[1]; if (validHandle(part)) handle = part; } catch (_) { /* unavailable */ }
      }
      map.set(item.product_id, {...metadata, ...item, handle, local: false});
    }
    return [...map.values()];
  }
  function notify(text) {
    const toast = document.querySelector('[data-bsw-toast]');
    toast.textContent = text; toast.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { toast.hidden = true; }, 4500);
  }
  async function api(action, data, keepalive = false) {
    if (!enabled) throw new Error('sync_error');
    const query = new URLSearchParams({action});
    const options = {method: data ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', keepalive};
    if (data) {
      options.body = JSON.stringify(data);
      const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(options.body));
      query.set('body_sha256', [...new Uint8Array(digest)].map(x => x.toString(16).padStart(2, '0')).join(''));
      options.headers = {'Content-Type': 'application/json'};
    }
    const controller = new AbortController(); options.signal = controller.signal;
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(root + proxy.slice(1) + '/' + action + '?' + query, options);
      const body = await response.json();
      if (!response.ok || body.ok !== true) { const e = new Error(body.error || 'sync_error'); e.status = response.status; throw e; }
      if (customer && body.customer_id !== customer) throw new Error('customer_context_changed');
      return body;
    } finally { clearTimeout(timeout); }
  }
  function accept(result) {
    if (!Array.isArray(result.items) || !result.items.every(x => x && validID(x.product_id))) throw new Error('sync_error');
    server = result.items; mode = 'account';
  }
  function pending() { return parse(read(pendingKey)); }
  async function sendPending() {
    const op = pending();
    if (!op) return;
    if (!['add', 'remove', 'sync'].includes(op.action) || op.body?.expected_customer_id !== customer) throw new Error('pending');
    let result;
    try { result = await api(op.action, op.body); }
    catch (e) {
      // A context change must never discard or replay an operation under another account.
      if (e.message !== 'customer_context_changed' && [400,409,413,415,422].includes(e.status)) write(pendingKey, null);
      throw e;
    }
    accept(result);
    if (op.action === 'sync') {
      const rejected = new Set(result.unavailable_product_ids || []);
      const accepted = new Set(server.map(x => x.product_id));
      for (const item of op.snapshot || []) {
        // On a duplicate, do not recreate an old sync whose item was subsequently removed elsewhere.
        // Keep unknown IDs locally unless the response confirms they are in the account list.
        if (rejected.has(item.product_id) || (result.duplicate && !accepted.has(item.product_id))) {
          const now = parse(read(itemKey + item.product_id));
          if (now?.token === item.token) write(itemKey + item.product_id, {...now, blocked:true});
          continue;
        }
        const now = parse(read(itemKey + item.product_id));
        if (now?.token === item.token) write(itemKey + item.product_id, null);
      }
    }
    if (pending()?.body?.request_id === op.body.request_id) write(pendingKey, null);
  }
  async function operation(action, data, snapshot = []) {
    if (pending()) throw new Error('pending');
    write(pendingKey, {action, body: {request_id: uuid(), expected_customer_id: customer, ...data}, snapshot});
    await sendPending();
  }
  function errorText(error) {
    if (error.message === 'unavailable') return t('unavailable');
    if (error.message === 'storage_error') return t('storage_error');
    if (error.message === 'list_limit_200' || error.message === 'limit') return t('limit');
    return t(pending() && customer ? 'pending' : 'sync_error');
  }
  async function exclusive(fn) {
    if (busy) return;
    busy = true; paint();
    try {
      if (navigator.locks) await navigator.locks.request('bsw-state', fn);
      else await fn();
    } catch (e) { message = errorText(e); retry = enabled && !!customer; notify(message); }
    finally { busy = false; paint(); if (dialog.open) render(); }
  }
  async function refresh() {
    if (!enabled || !customer) { paint(); return; }
    await exclusive(async () => {
      message = ''; retry = false;
      try {
        // Verify current identity before replaying any persisted operation.
        accept(await api('list'));
        await sendPending();
        const snapshot = localItems().filter(item => !item.blocked);
        if (snapshot.length) await operation('sync', {product_ids: snapshot.map(x => x.product_id)}, snapshot);
      } catch (e) {
        if (!pending() || e.message === 'customer_context_changed') { mode = 'device'; server = []; }
        throw e;
      }
    });
  }
  function guestId() {
    let value = parse(read(key + 'guest'));
    if (!/^[a-f0-9]{64}$/.test(value || '')) {
      value = [...crypto.getRandomValues(new Uint8Array(32))].map(x => x.toString(16).padStart(2, '0')).join('');
      write(key + 'guest', value);
    }
    return value;
  }
  // Telemetry is best effort. Failure must not undo a user's saved product.
  function event(type, id) {
    if (!enabled || (customer && type !== 'open_product') || (customer && mode !== 'account')) return;
    try {
      const body = {request_id: uuid(), product_id: id, event: type};
      if (customer) body.expected_customer_id = customer; else body.guest_id = guestId();
      void api('event', body, true).catch(() => {});
    } catch (_) { /* Statistics only reflect delivered events. */ }
  }
  async function toggle(id, metadata) {
    if (!validID(id)) return;
    await exclusive(async () => {
      if (customer && pending()) throw new Error('pending');
      const existing = items().find(x => x.product_id === id);
      if (mode === 'account' && !existing?.local) {
        const check = await api('list'); accept(check);
        const saved = server.some(x => x.product_id === id);
        await operation(saved ? 'remove' : 'add', {product_id: id});
        if (!saved && !server.some(x => x.product_id === id)) throw new Error('unavailable');
        notify(t(saved ? 'removed' : 'added'));
      } else {
        if (existing) { write(itemKey + id, null); event('remove', id); }
        else {
          if (localItems().length >= 200) throw new Error('limit');
          if (!validHandle(metadata?.handle)) return;
          write(itemKey + id, {product_id:id,handle:metadata.handle,title:String(metadata.title || '').slice(0,500),image:imageURL(metadata.image),token:uuid(),at:Date.now()});
          event('add', id);
        }
        notify(t(existing ? 'removed' : 'added'));
      }
      message = ''; retry = false;
    });
  }
  function discover() {
    for (const button of document.querySelectorAll('[data-bsw-toggle]')) {
      const id = button.dataset.productId;
      if (validID(id)) catalog.set(id, {handle:button.dataset.productHandle,title:button.dataset.productTitle,image:button.dataset.productImage});
    }
    paint();
  }
  function paint() {
    const saved = new Set(items().map(x => x.product_id));
    for (const button of document.querySelectorAll('[data-bsw-toggle]')) {
      const pressed = saved.has(button.dataset.productId);
      button.hidden = false; button.disabled = busy;
      button.setAttribute('aria-pressed', String(pressed));
      button.setAttribute('aria-label', t(pressed ? 'remove_label' : 'add') + ': ' + (button.dataset.productTitle || ''));
      const label = button.querySelector('[data-bsw-label]'); if (label) label.textContent = t(pressed ? 'saved' : 'add');
    }
    for (const button of document.querySelectorAll('[data-bsw-open]')) button.hidden = false;
    for (const badge of document.querySelectorAll('[data-bsw-count]')) { badge.textContent = String(saved.size); badge.hidden = saved.size === 0; }
    const modeNote = dialog.querySelector('[data-bsw-mode]');
    if (modeNote) { modeNote.textContent = ''; modeNote.hidden = true; }
    const status = dialog.querySelector('[data-bsw-status]');
    status.textContent = !storageOK ? t('storage_error') : message;
    status.hidden = !status.textContent;
    const retryButton = dialog.querySelector('[data-bsw-retry]'); retryButton.hidden = !retry; retryButton.disabled = busy;
    for (const button of dialog.querySelectorAll('[data-bsw-remove]')) button.disabled = busy;
  }
  function node(tag, className, text) { const el = document.createElement(tag); el.className = className; if (text) el.textContent = text; return el; }
  function render() {
    const container = dialog.querySelector('[data-bsw-items]');
    const focusId = document.activeElement?.dataset?.bswRemove;
    const all = items(); container.replaceChildren();
    if (!all.length) {
      const empty = node('div', 'bsw-empty');
      const icon = document.querySelector('.bsw-heart'); if (icon) empty.append(icon.cloneNode(true));
      empty.append(node('h3','Heading u-h4',t('empty')),node('p','bsw-note',t('empty_hint'))); container.append(empty);
    }
    for (const item of all) {
      const meta = hydrated.get(item.product_id) || {};
      const row = node('article','bsw-item ProductItem');
      const src = imageURL(meta.image || item.image || '');
      const visual = node(src ? 'img' : 'div','bsw-image');
      if (src) { visual.src = src; visual.alt = ''; visual.loading = 'lazy'; } else visual.setAttribute('aria-hidden','true');
      const content = node('div','bsw-item-info');
      const title = meta.title || item.title || item.product_id;
      const heading = node('h3','Heading'); content.append(heading);
      const available = item.available !== false && meta.missing !== true && validHandle(item.handle);
      if (available) {
        const link = node('a','',title); link.href = productURL(item.handle); link.dataset.bswVisit = item.product_id; heading.append(link);
      } else { heading.textContent = title; content.append(node('p','',t('unavailable'))); }
      if (item.local && mode === 'account') content.append(node('p','',t('local_only')));
      const remove = node('button','bsw-remove'); remove.type = 'button'; remove.dataset.bswRemove = item.product_id; remove.disabled = busy;
      remove.setAttribute('aria-label',t('remove_label') + ': ' + title);
      const cross = document.createElementNS('http://www.w3.org/2000/svg','svg');
      cross.setAttribute('viewBox','0 0 24 24'); cross.setAttribute('aria-hidden','true'); cross.setAttribute('focusable','false');
      const lines = document.createElementNS('http://www.w3.org/2000/svg','path');
      for (const [name,value] of Object.entries({d:'M6 6L18 18M18 6L6 18',fill:'none',stroke:'currentColor','stroke-width':'1','stroke-linecap':'round'})) lines.setAttribute(name,value);
      cross.append(lines); remove.append(cross);
      if (available) {
        const pictureLink = node('a',''); pictureLink.href = productURL(item.handle); pictureLink.dataset.bswVisit=item.product_id;
        pictureLink.setAttribute('aria-label',meta.title || item.title || item.product_id); pictureLink.append(visual); row.append(pictureLink);
      } else row.append(visual);
      row.append(content,remove); container.append(row);
    }
    if (focusId) (container.querySelector(`[data-bsw-remove="${focusId}"]`) || dialog.querySelector('[data-bsw-close]')).focus();
    paint();
    hydrate(all);
  }
  async function hydrate(all) {
    const generation = ++hydrateRun;
    const queue = all.filter(x => validHandle(x.handle) && !hydrated.has(x.product_id));
    async function worker() {
      while (queue.length && dialog.open && generation === hydrateRun) {
        const item = queue.shift(); hydrated.set(item.product_id, {});
        try {
          const response = await fetch(productURL(item.handle)+'.js', {credentials:'same-origin'});
          if (response.status === 404) hydrated.set(item.product_id, {missing:true});
          else if (response.ok) { const p = await response.json(); hydrated.set(item.product_id, {title:p.title,image:p.featured_image}); }
        } catch (_) { /* Retain saved metadata when offline; do not label product unavailable. */ }
      }
    }
    if (!queue.length) return;
    await Promise.all([worker(),worker(),worker()]);
    if (dialog.open && generation === hydrateRun) render();
  }
  function open(button) {
    opener = button; render();
    if (typeof dialog.showModal !== 'function') { notify(t('sync_error')); return; }
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('bsw-open');
    dialog.querySelector('[data-bsw-close]').focus();
    hydrate(items());
  }
  dialog.addEventListener('close', () => { ++hydrateRun; document.documentElement.classList.remove('bsw-open'); opener?.focus(); });
  dialog.addEventListener('click', e => { if (e.target === dialog) { const r=dialog.getBoundingClientRect(); if (e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) dialog.close(); } });
  document.addEventListener('click', e => {
    const target = e.target.closest?.('[data-bsw-open],[data-bsw-close],[data-bsw-toggle],[data-bsw-remove],[data-bsw-retry],[data-bsw-visit],a[href="#swym-wishlist"],a[href="#bs-wishlist"]');
    if (!target) return;
    if (target.hasAttribute('data-bsw-visit')) { event('open_product',target.dataset.bswVisit); return; }
    e.preventDefault(); e.stopPropagation();
    if (target.hasAttribute('data-bsw-open') || target.tagName === 'A') open(target);
    else if (target.hasAttribute('data-bsw-close')) dialog.close();
    else if (target.hasAttribute('data-bsw-retry')) void refresh();
    else { const id = target.dataset.productId || target.dataset.bswRemove; void toggle(id,catalog.get(id)); }
  });
  let scheduled = false;
  new MutationObserver(records => {
    if (scheduled || !records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && !dialog.contains(n) && (n.matches?.('[data-bsw-toggle],[data-bsw-open]') || n.querySelector?.('[data-bsw-toggle],[data-bsw-open]'))))) return;
    scheduled = true; queueMicrotask(() => { scheduled = false; discover(); });
  }).observe(document.body, {childList:true,subtree:true});
  window.addEventListener('storage', e => { if (e.key?.startsWith(key) || e.key === null) { paint(); if(dialog.open) render(); } });
  window.addEventListener('online', () => { if(retry) void refresh(); });
  window.addEventListener('pageshow', e => { if(e.persisted) location.reload(); });
  window.addEventListener('pagehide', () => { server=[]; mode='device'; if(dialog.open) dialog.close(); dialog.querySelector('[data-bsw-items]').replaceChildren(); });
  document.addEventListener('visibilitychange', () => { if(!document.hidden && enabled && customer) void refresh(); });
  window.BSWishlist = {open: () => open(document.querySelector('[data-bsw-open]')), refresh};
  discover(); void refresh();
  if (['#swym-wishlist','#bs-wishlist'].includes(location.hash)) open(document.querySelector('[data-bsw-open]'));
})();
